import { ElMessage } from "element-plus";
import useLogin from "@/stores/login";
import {
  applyRequestEncryption,
  applyResponseDecryption,
} from "@/request/apiCrypto";
//进行axios二次封装：使用请求与响应拦截器
import axios from "axios";
//利用element-ui Message做消息提示
//引入路由
import router from "@/router/index";

// 根据环境变量设置基础URL
const getBaseURL = () => {
  // 确保环境变量已定义
  const env = process.env.VUE_APP_ENV;
  // const apiUrl = process.env.VUE_APP_API_BASE_URL;
  
  if (env === 'development') {
    return '/api'; // 开发环境下继续使用代理
  } else {
    // 其他环境使用环境变量配置的API地址，如果未定义则默认使用 /api
    return '/api';
  }
};

//利用axios对象的create方法创建一个新的axios对象
const service = axios.create({
  //设置基础路径
  baseURL: getBaseURL(), // 使用动态基础URL
  timeout: 480000, //设置超时时间
});

// 为不同用途创建单独的服务实例
const service1 = axios.create({
  baseURL: getBaseURL(), // 使用相同的基础URL策略
  timeout: 480000,
});

//请求拦截器
service.interceptors.request.use((config) => {
  // config.headers['Authorization'] = userInformation.token // 让每个请求携带自定义token 请根据实际情况自行修改
  // if (userInformation.code && userInformation.code != "") {
  //     config.headers['code'] = userInformation.code
  // }
  //   config.headers["Access-Control-Allow-Origin"] = "*";
  //   config.headers["Content-Type"] = "application/json";
  //config配置对象，headers属性请求头，经常给服务器端携带公共参数
  const login = useLogin();
  if (login.code && login.code != "") {
    config.headers["code"] = login.code;
  }
  return applyRequestEncryption(config);
});
//请求拦截器
service1.interceptors.request.use((config) => {
  const login = useLogin();
  config.headers["Authorization"] = login.token; // 让每个请求携带自定义token 请根据实际情况自行修改
  if (login.code && login.code != "") {
    config.headers["code"] = login.code;
  }
  //   config.headers["Access-Control-Allow-Origin"] = "*";
  //   config.headers["Content-Type"] = "application/json";
  //config配置对象，headers属性请求头，经常给服务器端携带公共参数
  return applyRequestEncryption(config);
});
/**
 * 退出账号
 */
const exit = () => {
  const login = useLogin();
  login.isLogin = false;
  login.token = "";
  login.agencyId = undefined;
  login.code=undefined;
  login.userId = undefined;
  login.roleId = -1;
  login.username = undefined;
  router.push({ path: "/index" });
};
//响应拦截器
service.interceptors.response.use(
  (response) => {
    response.data = applyResponseDecryption(response);
    //response响应对象，data属性是服务器端返回的数据
    // let message = ''
    //http状态码：400 401 403 404 500 501 502 503 504
    // const status = response.data.code
    if (response.data?.code == 401) {
      //未登录code为100
      //利用element-ui Message做消息提示
      ElMessage.error("身份信息无效");
      exit();
    } else {
      return response.data;
    }
    return response.data;
  },
  (error) => {
    //失败的回调函数：处理http状态码不是200的情况
    //error对象中包含的信息：config请求配置对象，response响应对象，request请求对象
    //定义一个变量用于存储错误信息
    let message = "";
    if (error.response) {
      try {
        error.response.data = applyResponseDecryption(error.response);
      } catch {
        /* 保持原始错误体 */
      }
    }
    //http状态码：400 401 403 404 500 501 502 503 504
    if(error.response!=null){
      const status = error.response.status;
      switch (status) {
        case 400:
          message = "请求参数错误";
          break;
        case 401:
          message = "身份信息无效";
          exit();
          break;
        case 403:
          message = "没有操作权限";
          break;
        case 404:
          message = "请求资源不存在";
          break;
        case 500:
          message = "服务器内部错误";
          break;
        case 503:
          message = "服务器正在维护";
          break;
        case 504:
          message = "服务器超时";
          break;
        default:
          message = "未知错误";
          break;
      }
      //利用element-ui Message做消息提示
      ElMessage.error(message);
    }

    //创建一个失败的promise对象
    return Promise.reject(error);
  }
);
//响应拦截器
service1.interceptors.response.use(
  (response) => {
    response.data = applyResponseDecryption(response);
    //response响应对象，data属性是服务器端返回的数据
    // let message = ''
    //http状态码：400 401 403 404 500 501 502 503 504
    // const status = response.data.code
    if (response.data?.code == 401) {
      //未登录code为100
      //利用element-ui Message做消息提示
      ElMessage.error("身份信息无效");
      exit();
    } else {
      return response.data;
    }
    return response.data;
  },
  (error) => {
    //失败的回调函数：处理http状态码不是200的情况
    //error对象中包含的信息：config请求配置对象，response响应对象，request请求对象
    //定义一个变量用于存储错误信息
    let message = "";
    if (error.response) {
      try {
        error.response.data = applyResponseDecryption(error.response);
      } catch {
        /* 保持原始错误体 */
      }
    }
    console.log(error)
    //http状态码：400 401 403 404 500 501 502 503 504
    if(error.response!=null){
      const status = error.response.status;
      switch (status) {
        case 400:
          message = "请求参数错误";
          break;
        case 401:
          message = "身份信息无效";
          exit();
          break;
        case 403:
          message = "没有操作权限";
          break;
        case 404:
          message = "请求资源不存在";
          break;
        case 500:
          message = "服务器内部错误";
          break;
        case 503:
          message = "服务器正在维护";
          break;
        case 504:
          message = "服务器超时";
          break;
        default:
          message = "未知错误";
          break;
      }
      //利用element-ui Message做消息提示
      ElMessage.error(message);
    }

    //创建一个失败的promise对象
    return Promise.reject(error);
  }
);
//对外暴露一个service对象
export { service, service1 };
